export interface DigestTemplateType {
  name: string;
  sections: Array<{ section: string; text: string }>;
  cronExpression?: string;
}

export type DigestTemplateKey = "oncall_retrospective";

const oncallRetrospectiveText = (teamName: string) => `Please generate a report of all alerts that fired for our team (${teamName}) over the past 7 days.

### Time Window
1 week. Use the last 00:00:00 UTC to 00:00:00 UTC 7 days ago.

### Scope
The following should be considered for this analysis:
- alerts that were investigated by you for our team (${teamName})
- alerts that triggered in the following Slack channel: <REPLACE_WITH_SLACK_CHANNEL_NAMES>

### Guidelines
- Format according to source, e.g. Slack channel (#<channel_name>), Datadog alert (monitor ID), etc.
- Be concise and compact.
- Consolidate occurrences of the same alert into a single entry, if applicable.
- It's important to point out severity and customers affected.

### Report Format

\`\`\`
Summary [Date/Time Range]

### High-Level Status
- Total Unique Alerts: <total unique>
- Total Alerts: <total volume>

### Key Issues
<3-4 bullet points describing the highest severity or impacting alerts during this time period, include any that are important for the next oncall person>

### Action Items
<3-4 recommended action items from alerts and investigations during this time period, e.g. alert tuning, underlying fixes, etc.>
\`\`\``;

export function getDigestTemplate(key: DigestTemplateKey, teamName: string): DigestTemplateType | null {
  if (key === "oncall_retrospective") {
    return {
      name: `Oncall Retrospective (${teamName})`,
      sections: [
        {
          section: "Alerts Summary",
          text: oncallRetrospectiveText(teamName),
        },
      ],
      // Weekly: every Monday at 09:00 UTC
      cronExpression: "0 9 * * 1",
    };
  }
  return null;
}
